import React from "react";
import { Skeleton } from "../common/Skeleton";

export function FormSkeleton({ fields = 6, className = "" }) {
  return (
    <div className={`mx-auto max-w-2xl space-y-6 p-4 ${className}`}>
      <Skeleton className="h-8 w-1/3" />
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
      ))}
      <div className="flex justify-end gap-3 pt-2">
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-10 w-28" />
      </div>
    </div>
  );
}

export default FormSkeleton;
